import * as React from 'react';
import { PersonAccounts } from '../../type';
import { ActorApiMapper } from '../../../../../../components';
import { personAccountsLoadingData } from '../../loadingData';
import { usePersonsAccountsList } from '../../hooks';

export const PersonsAccountsMapper = (props: React.PropsWithChildren<{
  filterPredicate?: (data: PersonAccounts) => boolean,
  limit?: number,
  loadingList?: any[],
}>) => {
  const {
    filterPredicate,
    limit,
    loadingList,
    children,
  } = props;
  const {
    data,
    isLoading,
    error,
  } = usePersonsAccountsList({
    filterPredicate,
  });
  return (
    <ActorApiMapper
      data={data}
      isLoading={isLoading}
      error={error}
      loadingList={loadingList ?? personAccountsLoadingData}
      limit={limit}
    >
      {children}
    </ActorApiMapper>
  );
};
